import { getHeightRatioParentToChild } from '../../../../helpers/utils';

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    showIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      serviceNameFontSize: 'max(2.34375vw, 30px)',
    }
  },
  computed: {
    fontNormalFamily() {
      return this.$store.fontNormalFamily
    },
    currentLanguage() {
      return this.$store.currentLanguage;
    }
  },
  watch: {
    fontNormalFamily() {
      this.fitFontSize();
    },
    item: {
      handler() {
        this.fitFontSize();
      },
      immediate: true
    },
    currentLanguage() {
      this.fitFontSize();
    }
  },
  methods: {
    fitFontSize() {
      this.$nextTick(() => {
        if(this.$store.isDeviceMobile) {
          this.$refs['serviceName'].style.fontSize = '17px';
          return;
        }
        this.$refs['serviceName'].style.fontSize = this.serviceNameFontSize;

        let ratio;
        let counter = 0;

        while ((ratio = getHeightRatioParentToChild(this.$refs['serviceName'])) < 1) {
          if(counter++ > 10000) {
            break;
          }
          this.fit(ratio);
        }
      });
    },
    fit(ratio) {
      const titleFontSize = parseInt(getComputedStyle(this.$refs['serviceName']).getPropertyValue('font-size'));

      if (ratio < 1) {
        this.$refs['serviceName'].style.fontSize = (titleFontSize - 1) + 'px';
      }
    }
  },
  mounted() {
    setTimeout(() => this.fitFontSize());
    setTimeout(() => this.fitFontSize(), 150);
  }
};
